import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { SwitchButton } from "../../splash/SwitchButton";
import { BoardManagerAI } from "../BoardManagerAI";
import { RectangleWithRadius } from "../../utils/RectangleWithRadius";

export class ColorSelectionContainer extends Phaser.Group {

    private kingImage: Phaser.Image;

    constructor(game: Phaser.Game, waitingLayer?: boolean) {

        super(game, null, "color-selection-container");

        const colorLabel = new Phaser.Text(this.game, 0, -100, GameVars.texts[GameVars.language]["YOUR COLOUR"], { font: "46px Roboto Slab Bold", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        colorLabel.anchor.x = .5;
        this.add(colorLabel);

        const w = 288;
        const h = 76;

        const rectangleWithRadius = new RectangleWithRadius(this.game, -w / 2, -h / 2, w, h, 12, "#F6F9EF", .85);
        this.add(rectangleWithRadius);

        let switchButton: SwitchButton;

        if (waitingLayer) {

            let kingTextureName: string;
            let isSwitchButtonOn: boolean;

            if (GameVars.colorPlayer === GameConstants.WHITE) {
                kingTextureName = "white_king.png";
                isSwitchButtonOn = true;
            } else {
                kingTextureName = "black_king.png";
                isSwitchButtonOn = false;
            }

            this.kingImage = new Phaser.Image (this.game, -80, -36, "texture_atlas_1", kingTextureName);
            switchButton = new SwitchButton(this.game, isSwitchButtonOn, "switch_colour_white.png", "switch_colour_black.png", this);  

        } else {

            this.kingImage = new Phaser.Image (this.game, -80, -36, "texture_atlas_1", "white_king.png");
            switchButton = new SwitchButton(this.game, true, "switch_colour_white.png", "switch_colour_black.png", this);  
        }

        this.kingImage.scale.set(.75);
        this.add(this.kingImage);

        switchButton.x = 9;
        switchButton.y = -28;
        this.add(switchButton);
    }

    public switched(switchButton: SwitchButton): void {

        if (switchButton.isOn) {

            this.kingImage.frameName = "white_king.png";

            if (GameVars.againstAI) {
                BoardManagerAI.setPlayerColor(GameConstants.WHITE);
            }
            
        } else {

            this.kingImage.frameName = "black_king.png";

            if (GameVars.againstAI) {
                BoardManagerAI.setPlayerColor(GameConstants.BLACK);
            }
        }
    }
}

